export default "__VITE_ASSET__d3f0831d__"